import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

const TransactionIcon = () => (
  <svg width="24px" height="24px" viewBox="0 0 34 27" fill={COLOR_TEXT_MAIN} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34 12L20 0V9H5.5C4.67157 9 4 9.67157 4 10.5C4 11.3284 4.67157 12 5.5 12L20 12L20.5 12L34 12Z"
      fill="#4C566C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.04907e-06 15L14 27L14 18L28.5 18C29.3284 18 30 17.3284 30 16.5C30 15.6716 29.3284 15 28.5 15L14 15L12.5 15L1.04907e-06 15Z"
      fill="#4C566C"
    />
  </svg>
);

export default TransactionIcon;
